const Backofficebff: string = import.meta.env.VITE_BACKOFFICEBFF!;

const base = Backofficebff + '/v1/runtime-configurations';

export const RuntimeConfigurationQuery = {
    RUNTIME_CONFIGURATION_LIST: base,
    RUNTIME_CONFIGURATION_GET: (key: string) => `${base}/${encodeURIComponent(key)}`,
    RUNTIME_CONFIGURATION_VERSIONS: (key: string) => `${base}/${encodeURIComponent(key)}/versions`,
};

export const RuntimeConfigurationCommand = {
    RUNTIME_CONFIGURATION_CREATE: base,
    RUNTIME_CONFIGURATION_UPDATE_VALUE: (key: string) => `${base}/${encodeURIComponent(key)}/value`,
    RUNTIME_CONFIGURATION_UPDATE_METADATA: (key: string) => `${base}/${encodeURIComponent(key)}/metadata`,
    RUNTIME_CONFIGURATION_PUBLISH_VERSION: (key: string) => `${base}/${encodeURIComponent(key)}/publish-version`,
    RUNTIME_CONFIGURATION_DELETE: (key: string) => `${base}/${encodeURIComponent(key)}`,
};
